import { useParams } from '@tanstack/react-router';

/**
 * The link token of the room this screen is in.
 *
 * **The one place a chat component reaches for the router**, and it is worth
 * saying why rather than letting it spread. `ChatRoomView` deliberately carries
 * NO token and no room identifier (spec §5): the identifier stays on the server
 * and the two links are shown once, at the creation. So a component that has to
 * CALL the API - close the room, read the transcript - cannot get the token
 * from the room it was handed, and the token is not something to invent a
 * second channel for.
 *
 * Passing it down as a prop was the other option and it is worse: every
 * intermediate component on the way from `routes/chat.$token.tsx` would carry a
 * credential it does not use, which is exactly how a token ends up logged or
 * put in a query string.
 *
 * `useParams({ from: '/chat/$token' })` and not `{ strict: false }`, so the
 * name of the parameter is checked against the route tree: a rename of the
 * route file would fail the typecheck here instead of handing back `undefined`
 * at runtime.
 *
 * Consequence for tests, and it is deliberate: a component that calls this hook
 * needs a router. The screens below therefore export their PRESENTATIONAL
 * halves - which take rows and render them - and those are what the component
 * suite exercises. What is left in the routed wrapper is the fetch, and the
 * capture script plays it against a real stack.
 */
export function useChatToken(): string {
  return useParams({ from: '/chat/$token' }).token;
}
